import { ROLES } from '@/auth/enums/auth.enum'

export const MEETINGS_VARIABLES = {
  MEETING_NOT_STARTED: 'The meeting has not started',
  MEETING_CONF_EXTENSION_NOT_AVAILABLE: 'No extensions available for conference',
  CUSTOMIZE_MEETINGS_PAGE: {
    name: 'customize',
    path: 'meetings/customize-meetings/class/:id/meeting/:meeting',
    router: true,
    route: 'meetings'
  },
  WAITING_ROOM_PAGE: {
    name: 'waitingRoom',
    path: 'meetings/waiting-room',
    router: true,
    route: 'waiting-room'
  },
  CLASSES_TAB: {
    name:'classes',
    path:'#',
    id:-4,
    route: 'classes'
  },
  EMPTY_MEETINGS: {
    name: 'noClasses',
    path:'#',
    id:-5,
    disabled:true
  },
  CALLS_TAB: {
    name: 'calls',
    path:'#',
    id:-6
  }
}

export const MENU_TO_REQUEST = {
  MY_CONTENT_CLASSES: 'MY_CONTENT_CLASSES',
  CLASSES_CLASSES: 'CLASSES_CLASSES',
  CLASSES_CLASSES_AND_MY_CONTENT: 'CLASSES_CLASSES_AND_MY_CONTENT'
}

export const PUBLIC_NAV = [
  {
    name: 'home',
    pathName: 'public.home',
  }, 
  {
    name: 'resources',
    submenu: [{
      name: 'institutions',
      pathName: 'public.institution',
    }]
  }
]

export const MAIN_MENU = [
  {
    name: 'home',
    pathName: 'private.portal',
    hideForRoles: [
      ROLES.EDUAC_AUTHOR,
    ]
  },
  {
    name: 'classes',
    hasToRequest: MENU_TO_REQUEST.CLASSES_CLASSES,
    submenu: [],
    hideForRoles: [
      ROLES.EDUAC_AUTHOR,
    ]
  },
  {
    name: 'myContent',
    hasToRequest: MENU_TO_REQUEST.MY_CONTENT_CLASSES,
    notHasToRequestForRoles: [
      ROLES.EDUAC_AUTHOR,
    ],
    submenu: [{
      name: 'all',
      pathName: 'private.myContent.all',
    }],
  },
  {
    name: 'bookstore',
    pathName: 'private.bookstore',
    hideForRoles: [
      ROLES.EDUAC_STUDENT,
    ],
  },
  {
    name: 'resources',
    submenu: [{
      name: 'about',
      pathName: 'private.aboutus',
    },{
      name: 'institutions',
      pathName: 'private.institution',
    },{
      name: 'contact',
      pathName: null,
      disabled: true
    },{
      name: 'faq',
      pathName: null,
      disabled: true
    },{
      name: 'training',
      pathName: null,
      disabled: true
    },{
      name: 'myTools',
      pathName: 'private.tools'
    }]
  }
]

export const FOOTER_TYPE = {
  COMMON: 'COMMON',
  COMPACT: 'COMPACT',
  NONE: 'NONE'
}

export const COLORS_BASE = {
  COMMON: 'COMMON',
  LIGHT: 'LIGHT',
}

export const DROPDOWN_EVENTS = {
  OPEN_ED_DROPDOWN: 'OPEN_ED_DROPDOWN'
}

export const USER_MODE_EVENTS = {
  UPDATE_MODE: 'UPDATE_USER_MODE'
}

export const NAV_IDS = {
  NAV_MOBILE: 'NAV_MOBILE',
  NAV: 'NAV',
}

export const LOADING_EVENTS = {
  SHOW: 'SHOW_LOADING',
  HIDE: 'HIDE_LOADING'
}

export const OFFLINE_MODE_EVENT : string = 'OFFLINE_MODE_EVENT';